import React from 'react';
import { getCardClasses } from '../../utils/styleUtils';

/**
 * Reusable Card component with consistent styling
 * 
 * @param {Object} props - Component props
 * @param {string} props.variant - Card variant (basic, feature, teamMember, etc.)
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Card content
 * @param {Function} props.onClick - Click handler (optional)
 * @param {Object} props.rest - Additional props
 */
const Card = ({ 
  variant = 'basic', 
  className = '', 
  children, 
  onClick,
  ...rest 
}) => {
  const cardClasses = getCardClasses(variant, className);

  return (
    <div
      className={cardClasses}
      onClick={onClick}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Card;